import React from "react";
import { withStyles } from "@material-ui/core/styles";
import styles from "../styles";
import localStyles from "./styles";
import { Grid } from "@material-ui/core";
import { withUserProfile } from "../../../../../../userProfile/userProfileContext";
import Select from "../../../../../common/StyledSelect";
import { compose } from "recompose";
import { HOOK_TYPE_OPTION } from "../../constants";
import constants from "../../DispatchPanel/constants";
import { postData } from "../../../../../../api/componentAPIs";
import MESSAGES from "../../../../../../appMessages";
import Events from "../../../../../../utilities/EventEmitter";
import { withSnackbar } from "notistack";
import isEqual from "lodash/isEqual";
import {
  canAddTrailer,
  getArrivedAtStopId,
  getTrailerOptions,
  getRelaxedTrailerValidationError,
  getStrictTrailerValidationError,
  trailerInputMatchesDropdownOption,
  checkValidDollyForTrailerHook,
  shouldShowDollyInput,
  getTrailerDisplayNumber,
  hasDollyValidationError,
} from "../utils";
import { getTrailerDetailsLabel } from "./constants";
import Action from "./Action";

class TrailerHook extends React.Component {
  constructor(props) {
    super(props);
    this.attachedTrailers = this.getCurrentTrailers();
    this.state = {
      hookTrailersError: [],
      hookTrailers: [this.getNewHookedTrailer()],
      selectedHookType: HOOK_TYPE_OPTION.Trailer,
      hookTypes: this.getHookTypes(),
      trailerListOptions: [],
      hookTrailerDollies: [this.getNewHookedDolly()],
      hookTrailerDolliesError: [],
    };
  }

  getNewHookedDolly = () => ({
    dollyNumber: null,
    dollyScac: null,
    dollyId: null,
    dollyStatus: null,
  });

  componentDidMount() {
    Events.on("trailerHooked", this.trailerHookedStatus);
    Events.on("bobtailProcessed", this.bobtailProcessedStatus);
    this.generateTrailerOptions();
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.routeData, this.props.routeData)) {
      this.attachedTrailers = this.getCurrentTrailers();
      this.setState({ hookTypes: this.getHookTypes() });
    }
    if (prevProps.trailerList != this.props.trailerList) {
      const hookTrailersError = this.getErrors();
      this.generateTrailerOptions(hookTrailersError);
    }
  }

  componentWillUnmount() {
    Events.off("trailerHooked", this.trailerHookedStatus);
    Events.off("bobtailProcessed", this.bobtailProcessedStatus);
  }

  generateTrailerOptions = (hookTrailersError=[]) => {
    const trailerListOptions = getTrailerOptions(this.props.trailerList, this.props.showTrailerScac);
    this.setState({trailerListOptions, hookTrailersError});
  }

  checkStatus = (data, type) => {
    const { success } = data;
    if (success) {
      this.onTrailerHookSucceed(type);
    } else {
      this.onTrailerHookFailed(type);
    }
  };

  trailerHookedStatus = (data) => {
    this.checkStatus(data, HOOK_TYPE_OPTION.Trailer);
  };

  bobtailProcessedStatus = (data) => {
    this.checkStatus(data, HOOK_TYPE_OPTION.Bobtail);
  };

  getCurrentTrailers = () => {
    return this.props.currentDriverRoutes
      .filter(
        (route) =>
          route.trailerNumber &&
          route.trailerNumber !== constants.TRAILER_NUMBER_FOR_BOBTAIL
      )
      .map(({ trailerNumber, trailerScac }) => ({
        trailerNumber,
        trailerScac,
      }));
  };

  isBobtail = () => {
    return this.props.currentDriverRoutes.filter(
      (route) => route.trailerNumber === constants.TRAILER_NUMBER_FOR_BOBTAIL
    ).length;
  };

  getHookTypes = () => {
    const isBobtailDisabled =
      this.attachedTrailers.length !== 0 || this.isBobtail();
    return Object.keys(HOOK_TYPE_OPTION).map((key) => ({
      label: HOOK_TYPE_OPTION[key],
      value: key,
      isDisabled: key === HOOK_TYPE_OPTION.Bobtail ? isBobtailDisabled : false,
    }));
  };

  handleTrailerNumberChange = (trailerIndex) => (value) => {
    // Select option uses `value`; fallback to `label` for creatable flow.
    const trailerNumber = value?.value ?? value?.label ?? null;
    const { trailerId, trailerStatus, trailerScac, isStraightTruck } = value ?? {};
    const hookTrailers = this.state.hookTrailers;
    hookTrailers[trailerIndex] = {
      ...hookTrailers[trailerIndex],
      trailerNumber: trailerNumber?.trim?.() || trailerNumber,
      trailerId: trailerId ?? null,
      trailerStatus,
      trailerScac: trailerScac ?? null,
      isStraightTruck
    };
    this.setState({ hookTrailers }, () =>
      this.updateTrailerNumberErrors({
        trailerIndex,
        trailerId,
        trailerStatus,
        isStraightTruck
      })
    );
  };

  updateTrailerNumberErrors = ({
    trailerIndex,
    trailerId,
    trailerStatus,
    isStraightTruck
  }) => {
    const hookTrailer = this.state.hookTrailers[trailerIndex];
    this.setState((prevState) => ({
      hookTrailersError: prevState.hookTrailersError.map(
        (hookTrailerError, index) => {
          if (index === trailerIndex) {
            return this.checkValidTrailerNumber({
              trailerNumber: hookTrailer?.trailerNumber,
              trailerId,
              trailerStatus,
              isStraightTruck,
            });
          }
          return hookTrailerError;
        }
      ),
    }));
  };

  getNewHookedTrailer = () => ({
    trailerNumber: null,
    trailerScac: null,
    dollyNumber: null,
    dollyScac: null,
  });

  handleDollyNumberChange = (dollyIndex) => (value) => {
    const dollyNumber = value?.value ?? null;
    const { dollyScac, dollyId, dollyStatus } = value ?? {};
    const hookTrailerDollies = [...this.state.hookTrailerDollies];
    hookTrailerDollies[dollyIndex] = {
      dollyNumber,
      dollyScac: dollyScac ?? null,
      dollyId: dollyId ?? null,
      dollyStatus: dollyStatus ?? null,
    };
    this.setState({ hookTrailerDollies }, () =>
      this.updateDollyNumberErrors({ dollyIndex, dollyId, dollyStatus })
    );
  };

  updateDollyNumberErrors = ({ dollyIndex, dollyId, dollyStatus }) => {
    this.setState((prevState) => ({
      hookTrailerDolliesError: prevState.hookTrailerDolliesError.map(
        (error, index) => {
          if (index === dollyIndex) {
            return this.checkValidDolly({ dollyId, dollyStatus });
          }
          return error;
        }
      ),
    }));
  };

  checkValidDolly = ({ dollyId, dollyStatus }) => {
    return checkValidDollyForTrailerHook({
      dollyId,
      dollyStatus,
      hookTrailerDollies: this.state.hookTrailerDollies,
      allowedDollyStatusesToHook: this.props.allowedDollyStatusesToHook ?? [],
    });
  };

  getDollyNumberErrors = () => {
    const { enableDollyHook } = this.props;
    if (!enableDollyHook) return [];
    
    const attachedTrailersCount = this.attachedTrailers.length;
    return this.state.hookTrailerDollies.map((dolly, index) => {
      if (!shouldShowDollyInput(attachedTrailersCount, index)) {
        return null;
      }
      return this.checkValidDolly({
        dollyId: dolly.dollyId,
        dollyStatus: dolly.dollyStatus,
      });
    });
  };

  addNewTrailer = () => {
    const newHookedTrailerData = this.getNewHookedTrailer();
    const { enableDollyHook } = this.props;
    this.setState((state) => ({
      hookTrailers: [...state.hookTrailers, newHookedTrailerData],
      hookTrailersError: [...state.hookTrailersError, null],
      ...(enableDollyHook && {
        hookTrailerDollies: [...state.hookTrailerDollies, this.getNewHookedDolly()],
        hookTrailerDolliesError: [...state.hookTrailerDolliesError, null],
      }),
    }));
  };

  removeHookTrailer = () => {
    const { hookTrailers, hookTrailersError, hookTrailerDollies, hookTrailerDolliesError } = this.state;
    const { enableDollyHook } = this.props;
    this.setState({
      hookTrailers: [...hookTrailers.splice(0, hookTrailers.length - 1)],
      hookTrailersError: [...hookTrailersError.splice(0, hookTrailersError.length - 1)],
      ...(enableDollyHook && {
        hookTrailerDollies: [...hookTrailerDollies.splice(0, hookTrailerDollies.length - 1)],
        hookTrailerDolliesError: [...hookTrailerDolliesError.splice(0, hookTrailerDolliesError.length - 1)],
      }),
    });
  };

  isRelaxedTrailerCreatableValid = ({ inputValue, selectOptions }) => {
    const t = inputValue && String(inputValue).trim();
    if (!t) return false;
    return !trailerInputMatchesDropdownOption(t, selectOptions);
  };

  getTrailerOptionsForRow = (hookTrailer, trailerListOptions) => {
    if (!this.props.relaxTrailerValidation) {
      return trailerListOptions;
    }
    const trailerNum = hookTrailer.trailerNumber && String(hookTrailer.trailerNumber).trim();
    if (!trailerNum) {
      return trailerListOptions;
    }
    const isInList = trailerInputMatchesDropdownOption(trailerNum, trailerListOptions);
    if (isInList) {
      return trailerListOptions;
    }
    return [
      ...trailerListOptions,
      { value: trailerNum, label: trailerNum, trailerId: null, trailerScac: null }
    ];
  };

  checkValidTrailerNumber = ({
    trailerNumber,
    trailerId,
    trailerStatus,
    isStraightTruck,
  }) => {
    const { allowedTrailerStatusesToHook, relaxTrailerValidation } = this.props;
    if (relaxTrailerValidation) {
      return getRelaxedTrailerValidationError({
        trailerNumber,
        attachedTrailers: this.attachedTrailers,
        hookTrailers: this.state.hookTrailers,
      });
    }
    return getStrictTrailerValidationError({
      trailerNumber,
      trailerId,
      trailerStatus,
      isStraightTruck,
      attachedTrailers: this.attachedTrailers,
      hookTrailers: this.state.hookTrailers,
      allowedTrailerStatusesToHook: allowedTrailerStatusesToHook ?? [],
    });
  };

  getTrailerNumberErrors = () => {
    return this.state.hookTrailers.map(({ trailerNumber, trailerId, trailerStatus, isStraightTruck }) =>
      this.checkValidTrailerNumber({
        trailerNumber,
        trailerId,
        trailerStatus,
        isStraightTruck,
      })
    );
  };

  getErrors = () => {
    return this.state.selectedHookType === HOOK_TYPE_OPTION.Trailer
      ? this.getTrailerNumberErrors()
      : [];
  };

  getAllErrors = () => {
    return {
      trailerErrors: this.getErrors(),
      dollyErrors: this.getDollyNumberErrors(),
    };
  };

  getPayloadDataByHookType = () => {
    const selectedHookType = this.state.selectedHookType;
    const { userData, routeData, trailerHookTime, enableDollyHook } = this.props;
    const { hookTrailerDollies } = this.state;
    const attachedTrailersCount = this.attachedTrailers.length;
    
    let requestData = {
      terminalCode: userData.userProfile.terminal.code,
      driverId: routeData.driverId,
      dispatchId: routeData.dispatchId,
    };
    if (selectedHookType === HOOK_TYPE_OPTION.Bobtail) {
      return {
        apiName: HOOK_TYPE_OPTION.Bobtail,
        requestData
      };
    }
    requestData = {
      ...requestData,
      trailerHookTime,
      equipments: this.state.hookTrailers.reduce((hookedTrailers, hookTrailer, index) => {
        const hasTrailer = this.props.relaxTrailerValidation
          ? hookTrailer.trailerNumber && String(hookTrailer.trailerNumber).trim()
          : hookTrailer.trailerId;
        if (!hasTrailer) {
          return hookedTrailers;
        }
        const dollyData = hookTrailerDollies[index];
        const includeDolly = enableDollyHook && shouldShowDollyInput(attachedTrailersCount, index);
        return [...hookedTrailers, {
          trailerNumber: hookTrailer.trailerNumber ?? null,
          trailerScac: hookTrailer.trailerScac ?? null,
          dollyNumber: includeDolly ? (dollyData?.dollyNumber ?? null) : null,
          dollyScac: includeDolly ? (dollyData?.dollyScac ?? null) : null,
        }]
      }, []),
      arrivedStopId: getArrivedAtStopId(routeData)
    }
    return {
      requestData,
      apiName: "TrailerHook",
    };
  }

  onHookTrailer = () => {
    const { trailerErrors, dollyErrors } = this.getAllErrors();
    this.setState({
      hookTrailersError: trailerErrors,
      hookTrailerDolliesError: dollyErrors,
    });
    const hasValidTrailerInputs = trailerErrors.every((v) => v === null);
    const hasValidDollyInputs = dollyErrors.every((v) => v === null);
    if (!hasValidTrailerInputs || !hasValidDollyInputs) {
      return;
    }
    const { requestData, apiName } = this.getPayloadDataByHookType();
    this.props.showHideLoader(true);
    postData(apiName, requestData)
      .then((response) => {
        if (response?.status !== 204) {
          this.onTrailerHookFailed(this.state.selectedHookType, response.status);
        }
      })
      .catch(() => {
        this.onTrailerHookFailed(this.state.selectedHookType);
      });
  };

  onTrailerHookFailed = (type, statusCode) => {
    this.props.showHideLoader(false);
    if (statusCode === 403) {
      return;
    }
    const msg =
      type === HOOK_TYPE_OPTION.Trailer
        ? MESSAGES.TRAILER_HOOKED.FAILURE
        : MESSAGES.BOBTAIL_PROCESSED.FAILURE;
    this.props.enqueueSnackbar(msg, {
      variant: "error",
    });
  };

  clearSelectedTrailers = () => {
    this.setState({
      hookTrailers: [this.getNewHookedTrailer()],
      hookTrailersError: [],
      hookTrailerDollies: [this.getNewHookedDolly()],
      hookTrailerDolliesError: [],
    });
  }

  onTrailerHookSucceed = (type) => {
    const msg =
      type === HOOK_TYPE_OPTION.Trailer
        ? MESSAGES.TRAILER_HOOKED.SUCCESS
        : MESSAGES.BOBTAIL_PROCESSED.SUCCESS;
    this.props.enqueueSnackbar(msg, {
      variant: "success",
    });
    this.props.showHideLoader(false);
    this.clearSelectedTrailers();
  };

  render() {
    const attachedTrailersCount = this.attachedTrailers.length;
    const { 
      classes, 
      isLoading, 
      maxAllowedTrailerCount, 
      routeData,
      enableDollyHook,
      dollyListOptions,
    } = this.props;
    const { hookTrailers, selectedHookType, trailerListOptions, hookTrailerDollies, hookTrailerDolliesError } = this.state;
    const isAddTrailerDisabled = canAddTrailer(
      attachedTrailersCount,
      hookTrailers.length,
      maxAllowedTrailerCount
    );
    const isLastEntry = hookTrailers.length === 1;
    const isBobtailSelected = selectedHookType === HOOK_TYPE_OPTION.Bobtail;
    const isCurrentStraightTruck = routeData.trailer?.isStraightTruck;
    const isSectionDisabled = (attachedTrailersCount >= maxAllowedTrailerCount) || isCurrentStraightTruck;
    const hasTrailerValidationError =
      !isBobtailSelected &&
      (this.state.hookTrailersError ?? []).some((msg) => msg != null && msg !== "");
    
    const hasDollyValidationErrorFlag = hasDollyValidationError({
      enableDollyHook,
      isBobtailSelected,
      attachedTrailersCount,
      hookTrailersLength: hookTrailers.length,
      hookTrailerDollies,
      hookTrailerDolliesError,
    });
    return (
      <Grid
        container
        className={`${classes.containerStyle} ${
          isSectionDisabled ? classes.sectionDisabled : null
        }`}>
        <Grid item xs={12}>
          <div className={classes.sectionTitle}>Trailer Hook</div>
          <div className={classes.flexRow}>
            <Select
              textFieldProps={{
                id: 'HookType',
                label: 'Hook Type',
                variant: 'outlined'
              }}
              value={this.state.selectedHookType}
              onChange={(val) =>
                this.setState({
                  selectedHookType: val?.value
                })
              }
              isNotClearable={true}
              data={this.state.hookTypes}
              rootClass={classes.selectRoot}
            />
          </div>
          {!isBobtailSelected &&
            this.state.hookTrailers.map((hookTrailer, hookTrailerIndex) => {
              const optionsForRow = this.getTrailerOptionsForRow(hookTrailer, trailerListOptions);
              const showDollyInput = enableDollyHook && shouldShowDollyInput(attachedTrailersCount, hookTrailerIndex);
              const trailerDisplayNumber = getTrailerDisplayNumber(attachedTrailersCount, hookTrailerIndex);
              const dollyData = hookTrailerDollies[hookTrailerIndex] ?? {};
              const dollyError = hookTrailerDolliesError[hookTrailerIndex];
              return (
                <React.Fragment key={hookTrailer.trailerId || `trailer-${hookTrailerIndex}`}>
                  {showDollyInput && (
                    <div className={classes.trailerDetailsLabel}>
                      {getTrailerDetailsLabel(trailerDisplayNumber)}
                    </div>
                  )}
                  <div className={classes.searchRow}>
                    <Select
                      value={hookTrailer.trailerNumber}
                      data={optionsForRow}
                      onChange={this.handleTrailerNumberChange(hookTrailerIndex)}
                      rootClass={classes.selectRootHook}
                      canAcceptNewValue={this.props.relaxTrailerValidation}
                      creatableIsValidNewOption={
                        this.props.relaxTrailerValidation
                          ? this.isRelaxedTrailerCreatableValid
                          : undefined
                      }
                      createLabel={this.props.relaxTrailerValidation ? 'Add Trailer' : undefined}
                      newValueParams={
                        this.props.relaxTrailerValidation
                          ? { placeholder: 'Type trailer number' }
                          : undefined
                      }
                      textFieldProps={{
                        id: 'hookTrailersList',
                        label: 'Trailer Number',
                        variant: 'outlined',
                        helperText: isSectionDisabled
                          ? ''
                          : this.state.hookTrailersError[hookTrailerIndex]
                      }}
                      error={
                        !isSectionDisabled && Boolean(this.state.hookTrailersError[hookTrailerIndex])
                      }
                    />
                  </div>
                  {showDollyInput && (
                    <div className={classes.dollyInputRow}>
                      <Select
                        value={dollyData.dollyNumber}
                        data={dollyListOptions ?? []}
                        onChange={this.handleDollyNumberChange(hookTrailerIndex)}
                        rootClass={classes.selectRootHook}
                        textFieldProps={{
                          id: `hookDollyList-${hookTrailerIndex}`,
                          label: 'Dolly Number',
                          variant: 'outlined',
                          helperText: isSectionDisabled ? '' : dollyError
                        }}
                        error={!isSectionDisabled && Boolean(dollyError)}
                      />
                    </div>
                  )}
                </React.Fragment>
              );
            })}
          <Action
            onAdd={this.addNewTrailer}
            onCancel={this.removeHookTrailer}
            onSubmit={this.onHookTrailer}
            disabledCancel={isLoading || isLastEntry || isSectionDisabled}
            disabledAdd={isLoading || isAddTrailerDisabled || isSectionDisabled}
            disableSubmit={
              isLoading || isSectionDisabled || hasTrailerValidationError || hasDollyValidationErrorFlag
            }
            isBobtailSelected={isBobtailSelected}
          />
        </Grid>
      </Grid>
    );
  }
}

export default compose(
  withSnackbar,
  withUserProfile,
  withStyles(
    (theme) => ({
      ...styles(theme),
      ...localStyles(theme),
    }),
    { withTheme: true }
  )
)(TrailerHook);
